/**
 * 應用級別 JavaScript - 全域功能
 * 包含所有頁面都需要的功能，如 flash messages
 */

// 引入 flash messages 功能
import 'utils/flashMessages';

// 引入全域時區和語言功能
import { initializeGlobalTimezone, initializeGlobalLocale, initializeLanguageSwitchers } from 'utils';

// 折價券註冊完成的 GA4 漏斗 event（由伺服器在發券後種下 cookie，這裡讀取後發送並清除）
import { trackEvent } from 'utils/analytics';

// 考試計算機結果下方「下一步」連結的點擊（雅思、日檢、TOPIK、EJU、BJT、多益共用，事件委派）
import { initCalculatorNextStepTracking } from 'utils/calculatorNextStepTracking';

// 引入可重用 Tab 組件
import 'components/tabs';

// 引入 Dashboard Sidebar 收合功能
import 'components/sidebar-toggle';

// Stimulus 設置
import { Application } from "@hotwired/stimulus"
import AccordionController from "../controllers/accordion_controller.js"
import PayoutAccountFormController from "../controllers/payout_account_form_controller.js"

// 初始化 Stimulus
const application = Application.start()
application.register("accordion", AccordionController)
application.register("payout-account-form", PayoutAccountFormController)

// 初始化全域時區和語言支援
document.addEventListener('DOMContentLoaded', () => {
  // 初始化全域時區處理 - 自動為所有 HTTP 請求添加時區 header
  initializeGlobalTimezone();

  // 初始化全域語言處理 - 自動為所有 HTTP 請求添加語言 header
  initializeGlobalLocale();

  // 初始化語言切換器 - 為所有語言選擇器綁定事件
  initializeLanguageSwitchers();

  // 計算機「下一步」連結點擊 → GA4 cta_click
  initCalculatorNextStepTracking();

  // 折價券註冊完成 → 發 GA4 event 一次後清除 cookie
  const match = document.cookie.match(/(?:^|;\s*)wc_signup_team=([^;]+)/);
  if (match) {
    trackEvent('welcome_coupon_signup', { team_slug: decodeURIComponent(match[1]) });
    document.cookie = 'wc_signup_team=; Max-Age=0; path=/';
  }
});

// 未來可以在此添加其他全域功能
// import 'utils/globalUtilities';
// import 'utils/analytics';
